import React from "react";

export const ASSET_STATUSES = ["Operational", "Issue", "Maintenance", "Do not use", "Retired"];
export const FAULT_STATUSES = ["Open", "In progress", "Resolved"];
export const PRIORITIES = ["Critical", "High", "Medium", "Low"];
export const MAINT_TYPES = ["Service", "Inspection", "Repair", "Calibration", "PAT test"];
export const PAT_RESULTS = ["Pass", "Fail"];
export const ASSET_CATEGORIES = ["Lighting fixture", "Loudspeaker", "Audio console", "Amplifier", "Projector", "Rigging", "Network", "Cable / accessory", "Effects", "Other"];

const COLORS = {
  Operational: "#10B981", Issue: "#F59E0B", Maintenance: "#3B82F6", "Do not use": "#EF4444", Retired: "#64748B",
  Open: "#EF4444", "In progress": "#F59E0B", Resolved: "#10B981",
  Critical: "#EF4444", High: "#F59E0B", Medium: "#3B82F6", Low: "#64748B",
  Done: "#10B981", Overdue: "#EF4444", Scheduled: "#3B82F6",
  "PAT valid": "#10B981", "PAT due soon": "#F59E0B", "PAT overdue": "#EF4444", Untested: "#64748B", Tested: "#3B82F6",
  Pass: "#10B981", Fail: "#EF4444",
};

export const statusColor = (s) => COLORS[s] || "#64748B";

export function StatusBadge({ value, testid }) {
  if (!value) return null;
  const c = statusColor(value);
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap"
      style={{ borderColor: c + "66", color: c, background: c + "1A" }}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: c }} />
      {value}
    </span>
  );
}
